import { Component, OnInit, TemplateRef, SimpleChanges, Input, ViewChild } from "@angular/core";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { DatepickerDateCustomClasses } from "ngx-bootstrap/datepicker";
import { PaginationService } from "src/app/PaginationService";
import { AppService } from "src/app/app.service";
import { messageService } from "src/app/message.service";
import { StaticAuditTrailComponent } from "src/app/support/static-audit-trail/static-audit-trail.component";
import { SuccessSnackbarComponent } from "src/app/support/success-snackbar/success-snackbar.component";


@Component({
  selector: 'app-distributed-folder',
  templateUrl: './distributed-folder.component.html',
  styleUrls: ['./distributed-folder.component.scss']
})
export class DistributedFolderComponent implements OnInit {

  @Input() folderData: any = {};
  isProcessing = false;
  distributedFoldersList: any = [];
  distributedData: any = {};
  searchValue: string = '';
  operationFlag: any;
  title = "";

  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  columnList: any = [{ column: "Parent Folder", width: "200px" }, { column: "Parent Folder Path", width: "240px" }, { column: "Parent Folder Status", width: "200px" },
  { column: "Child Folder", width: "200px" }, { column: "Child Folder Path", width: "240px" }, { column: "Document(s)", width: "240px" },
  { column: "Show History", width: "100px" }, { column: "Distributed Reason", width: "240px" }, { column: "Is Active", width: "100px" },
  { column: "Created On", width: "140px" }, { column: "Created By", width: "140px" }, { column: "Updated On", width: "140px" }, { column: "Updated By", width: "140px" }]

  visibleAddOrEditDistributedPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteDistributedPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditDistributedPopup', { static: true }) addOrEditDistributedPopup: TemplateRef<any>;
  @ViewChild('deleteDistributedPopup', { static: true }) deleteDistributedPopup: TemplateRef<any>;


  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  addOrEditDistributedPopupConfig = {
    width: '900px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteDistributedPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
  };

  constructor(public appService: AppService, private snackBar: MatSnackBar, public paginationService: PaginationService, public dialog: MatDialog, public message: messageService) {

  }

  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss'
  ngOnInit(): void {
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');


    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
  }

  refreshGrid() {
    this.isProcessing = true;
    this.appService.getDmsDistributedFolders(
      this.folderData['folderId']).subscribe((data: any) => {
        this.isProcessing = false;
        this.distributedFoldersList = data;
        this.collectionSize = this.distributedFoldersList.length;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isProcessing = true;
    this.appService.getDmsDistributedFolders(
      this.folderData['folderId']).subscribe((data: any) => {
        this.isProcessing = false;
        this.distributedFoldersList = data;
        this.collectionSize = this.distributedFoldersList.length;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
      })
  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.distributedFoldersList.length, page, this.perPage, targetpage);
    this.pagedItems = this.distributedFoldersList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;
      for (let p = 0; p < this.distributedFoldersList.length; p++) {
        this.distributedFoldersList[p].childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (let p = 0; p < this.distributedFoldersList.length; p++) {
        this.distributedFoldersList[p].childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    //console.log(e);
    //console.log(list);
    //console.log(idx);
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }


  addDocumentFunc(event: any) {
    this.distributedData = {};
    this.selectedDocList = [];
    this.distributedData['parentFolderId'] = null;
    this.distributedData['childFolderId'] = this.folderData['folderId'];
    this.distributedData['documentIdList'] = null;
    this.distributedData['documentNameList'] = null;
    this.distributedData['showHistory1'] = false;
    this.distributedData['isActive1'] = true;
    this.distributedData['distributedReason'] = null;
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.isShowTree = false;
    this.title = "Add Distributed Document";
    this.visibleAddOrEditDistributedPopup = this.dialog.open(this.addOrEditDistributedPopup, this.addOrEditDistributedPopupConfig);
  }

  editDocumentFunc(distributed: any, event: any) {
    this.distributedData = distributed;
    this.isProcessing = true;
    this.appService.getDmsDistributedFoldersById(this.distributedData.childFolderId, this.distributedData.distributedFolderId).subscribe((data: any) => {
      this.distributedData = data[0];
      this.isProcessing = false;
      this.distributedData.showHistory1 = this.distributedData.showHistory == "Y" ? true : false;
      this.distributedData.isActive1 = this.distributedData.isActive == "Y" ? true : false;

    })
    this.isShowTree = false;
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = "Update Distributed Document";
    this.visibleAddOrEditDistributedPopup = this.dialog.open(this.addOrEditDistributedPopup, this.addOrEditDistributedPopupConfig);
  }

  cancelAddAndEditFunction() {
    this.visibleAddOrEditDistributedPopup.close();
  }

  isShowTree: boolean = false;
  onTypeChanged(data: any) {
    if (data == "All Documents") {
      this.distributedData.documentIdList = 0;
      this.isShowTree = false;
    } else {
      this.isShowTree = true;
      this.distributedData.documentIdList = null;
      this.distributedData.documentNameList = null;
    }
  }


  model = {
    documentData: {
      isFrom: "",
      documentId: null
    },
  };
  selectedDocList: any = [];
  changeInFolderStructureChild(data: any) {
    this.model = data;
    if (this.model.documentData.isFrom != undefined && this.model.documentData.isFrom != null) {
      if (this.model.documentData.isFrom == "allDocuments") {
        this.selectedDocList = [];
      }
    }
    if (this.model.documentData.documentId != null) {
      this.selectedDocList.push(this.model.documentData);
    }

  }

  distReasonCss: any;
  distReasonReqdMsg: any;
  fieldValidation() {
    this.distReasonCss = document.getElementById('distReason') as HTMLInputElement;

    this.distReasonReqdMsg = document.getElementById('distReason-required-msg') as HTMLInputElement;

    if (this.distributedData.distributedReason == "" || this.distributedData.distributedReason == null) {
      this.distReasonCss.style.border = '1px solid red';
      this.distReasonReqdMsg.style.display = 'block';
    } else {
      this.distReasonCss.style.border = 'none';
      this.distReasonReqdMsg.style.display = 'none';
    }


  }

  addOrUpdateDistributed(distributedData: any) {
    debugger;
    if (this.distributedData.distributedReason == null) {
      this.fieldValidation();
    } else {
      this.isProcessing = true;
      if (this.distributedData.distributedFolderId == null || this.distributedData.distributedFolderId == undefined) {
        for (let i = 0; i < this.selectedDocList.length; i++) {
          if (this.distributedData['documentIdList'] == null) {
            this.distributedData['documentIdList'] = this.selectedDocList[i].documentId;
          } else {
            this.distributedData['documentIdList'] = this.distributedData['documentIdList'] + "," + this.selectedDocList[i].documentId;
          }
        }
        this.distributedData['parentFolderId'] = this.selectedDocList[0].folderId;
        this.distributedData['showHistory'] = this.distributedData['showHistory1'] ? "Y" : "N";
        this.distributedData['isActive'] = this.distributedData['isActive1'] ? "Y" : "N";
        this.appService.createDistributedFolder(this.distributedData).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleAddOrEditDistributedPopup.close();
            this.isProcessing = true;
            this.appService.getDmsDistributedFolders(
              this.folderData['folderId']).subscribe((data: any) => {
                this.isProcessing = false;
                this.distributedFoldersList = data;
                this.collectionSize = this.distributedFoldersList.length;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {
        delete this.distributedData['createdOn'];
        delete this.distributedData['updatedOn'];
        this.distributedData['showHistory'] = this.distributedData['showHistory1'] ? "Y" : "N";
        this.distributedData['isActive'] = this.distributedData['isActive1'] ? "Y" : "N";
        for (let i = 0; i < this.selectedDocList.length; i++) {
          if (i == 0) {
            this.distributedData['documentIdList'] = null;
            this.distributedData['documentNameList'] = null;

          }
          if (this.distributedData['documentIdList'] == null) {
            this.distributedData['documentIdList'] = this.selectedDocList[i].documentId;
          } else {
            this.distributedData['documentIdList'] = this.distributedData['documentIdList'] + "," + this.selectedDocList[i].documentId;
          }
        }
        this.appService.updateDistributedFolder(this.distributedData).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleAddOrEditDistributedPopup.close();
            this.isProcessing = true;
            this.appService.getDmsDistributedFolders(
              this.folderData['folderId']).subscribe((data: any) => {
                this.isProcessing = false;
                this.distributedFoldersList = data;
                this.collectionSize = this.distributedFoldersList.length;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      }
    }



  }

  reason: any;
  openDeletePopup(distributed: any, event: any) {
    this.distributedData = distributed;
    this.reason = null;
    this.title = "Delete Distributed Folder";
    this.visibleDeleteDistributedPopup = this.dialog.open(this.deleteDistributedPopup, this.deleteDistributedPopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeleteDistributedPopup.close();
  }

  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;

    if (this.reason == "" || this.reason == null || this.reason == undefined) {
      //reasonValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
      //reasonValidationIcon.style.color = 'red';
      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      //reasonValidationIcon.innerHTML = '';
      //reasonValidationIcon.style.color = 'none';
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }

  }

  deleteFunction() {
    if (this.reason == null) {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else {
      this.isProcessing = true;

      this.distributedData['deleteReason'] = this.reason;
      delete this.distributedData['createdOn'];
      delete this.distributedData['updatedOn'];
      this.appService.deleteDistributedFolder(this.distributedData).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
        }
        this.visibleDeleteDistributedPopup.close();
        this.isProcessing = true;
        this.appService.getDmsDistributedFolders(
          this.folderData['folderId']).subscribe((data: any) => {
            this.isProcessing = false;
            this.distributedFoldersList = data;
            this.collectionSize = this.distributedFoldersList.length;
            this.pager.totalPages = undefined;
            this.setPage(1, 0);
          })
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, distributedFolderData: any) {
    console.log(this.folderData);
    this.message.tableOrView_Name = "DMS_DISTRIBUTED_FOLDERS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,CHILD_FOLDER_NAME,CHILD_FOLDER_PATH,PARENT_FOLDER_NAME,PARENT_FOLDER_PATH,DOCUMENT_NAME_LIST,SHOW_HISTORY,DISTRIBUTED_REASON,IS_ACTIVE,ALL_PARENT_FOLDER_STATUS,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Child Folder Name,Child Folder Path,Parent Folder Name,Parent Folder Path,Document(s),Show History,Distributed Reason,Is Active,All Parent Folder Status,Created By,Created On,Updated By,Updated On,Deleted By,Deleted Reason";
    this.message.whereClause_AU = viewType == 'overAll' ? ' AND CHILD_FOLDER_ID = ' + this.folderData.folderId : ' AND CHILD_FOLDER_ID = ' + this.folderData.folderId + ' AND DISTRIBUTED_FOLDER_ID =' + distributedFolderData.distributedFolderId;
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Child Folder Name,Child Folder Path,Parent Folder Name,Parent Folder Path,Document(s),Show History,Distributed Reason,Is Active,All Parent Folder Status,Created By,Created On,Updated By,Updated On,Deleted By,Deleted Reason";
    this.message.whereClause_Report = viewType == 'overAll' ? ' WHERE CHILD_FOLDER_ID = ' + this.folderData.folderId : ' WHERE CHILD_FOLDER_ID = ' + this.folderData.folderId + ' AND DISTRIBUTED_FOLDER_ID =' + distributedFolderData.distributedFolderId;
    this.message.report_And_Popup_Name = "QMS Settings Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(0);
  }

}


